export enum AuthRequestType {
  AuthenticateAndUnlock = 0,
  Unlock = 1,
  AdminApproval = 2,
}
